module.exports = __webpack_public_path__ + "static/logo-7ebc0ad0b713b573f5ab170edfdd8d56.png";